var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdeaEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4252 13.3866C14.0197 13.705 13.7143 14.1784 13.7143 14.7168C13.7143 15.0965 13.4268 15.4044 13.0722 15.4044H10.9278C10.5732 15.4044 10.2857 15.0965 10.2857 14.7168C10.2857 14.1784 9.98026 13.705 9.57476 13.3866C8.61757 12.6348 8 11.4488 8 10.1144C8 7.84208 9.79086 6 12 6C14.2091 6 16 7.84208 16 10.1144C16 11.4488 15.3824 12.6348 14.4252 13.3866Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8571 16.5013C10.4707 16.5013 10.1574 16.8368 10.1574 17.2507C10.1574 17.6645 10.4707 18 10.8571 18H13.1429C13.5293 18 13.8426 17.6645 13.8426 17.2507C13.8426 16.8368 13.5293 16.5013 13.1429 16.5013H10.8571Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 19C3.57999 19 3.19022 18.8705 2.86841 18.6493L7.52219 13.375C7.83776 13.8261 8.21741 14.2279 8.64828 14.5662C8.71519 14.6188 8.75602 14.671 8.77552 14.7056C8.78117 14.7157 8.78421 14.7226 8.78574 14.7266C8.78758 15.1324 8.90482 15.5335 9.11544 15.8788C8.82259 16.272 8.65737 16.7578 8.65737 17.2507C8.65737 17.9172 8.95949 18.5707 9.47078 19H4Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.00001C2 6.66593 2.08191 6.35099 2.22674 6.07416L6.58562 9.12538C6.52933 9.44711 6.5 9.77769 6.5 10.1144C6.5 10.7493 6.60358 11.361 6.79495 11.9321L2.02789 17.3348C2.00955 17.2259 2 17.1141 2 17V7.00001Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17C22 17.1141 21.9905 17.2259 21.9721 17.3348L17.205 11.9321C17.3964 11.361 17.5 10.7493 17.5 10.1144C17.5 9.77768 17.4707 9.4471 17.4144 9.12537L21.7733 6.07416C21.9181 6.35098 22 6.66593 22 7V17Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1316 18.6493C20.8098 18.8705 20.42 19 20 19H14.5292C15.0405 18.5707 15.3426 17.9172 15.3426 17.2507C15.3426 16.7578 15.1774 16.272 14.8846 15.8788C15.0952 15.5335 15.2124 15.1324 15.2143 14.7266C15.2158 14.7226 15.2188 14.7157 15.2245 14.7056C15.244 14.671 15.2848 14.6188 15.3517 14.5662C15.7826 14.2279 16.1622 13.8261 16.4778 13.375L21.1316 18.6493Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 5C20.1992 5 20.3915 5.02911 20.5731 5.08331L16.9328 7.63148C16.3738 6.47605 15.4361 5.53867 14.2757 5H20Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42694 5.08331C3.60848 5.02911 3.80084 5 4 5H9.72427C8.56392 5.53867 7.62619 6.47605 7.06718 7.63148L3.42694 5.08331Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaEnvelope);
export default __webpack_public_path__ + "static/media/idea-envelope.edadee2c564d43dfca47423b6c702bd2.svg";
export { ForwardRef as ReactComponent };